var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightTicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96651 9.47606L11.138 6.30458C11.3983 6.04423 11.3983 5.62212 11.138 5.36177C10.8776 5.10142 10.4555 5.10142 10.1952 5.36177L7.0237 8.53325L7.96651 9.47606Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52904 11.7526L4.20448 10.4281C4.20136 10.4251 4.19826 10.422 4.19518 10.419L2.47132 8.6951C2.21097 8.43475 1.78886 8.43475 1.52851 8.6951C1.26816 8.95545 1.26816 9.37756 1.52851 9.63791L3.25237 11.3618C3.86816 11.9776 4.7856 12.1078 5.52904 11.7526Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4714 5.32856C14.7317 5.58891 14.7317 6.01102 14.4714 6.27137L9.38085 11.3619C8.5998 12.1429 7.33347 12.1429 6.55242 11.3619L4.82856 9.63803C4.56821 9.37768 4.56821 8.95557 4.82856 8.69522C5.08891 8.43487 5.51102 8.43487 5.77137 8.69522L7.49523 10.4191C7.75558 10.6794 8.17769 10.6794 8.43804 10.4191L13.5286 5.32856C13.7889 5.06821 14.211 5.06821 14.4714 5.32856Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTicks);
export default __webpack_public_path__ + "static/media/light-ticks.a98aa7fe860e883ae1384a1fe1d4a562.svg";
export { ForwardRef as ReactComponent };